module.exports = __webpack_public_path__ + "media/app/images/campaign_cta-8f15ccdf42b7a1ec05619b35b88b9607.png";